import { render, staticRenderFns } from "./product-markup.vue?vue&type=template&id=07b64841&"
import script from "./product-markup.vue?vue&type=script&lang=js&"
export * from "./product-markup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports